import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import EquipmentViewRow from 'components/ui/tailwind/equipment/EquipmentViewRow';
const HEADERS = [
    'Equipment ID',
    'Type',
    'Equipment Type',
    'Size',
    'Owner',
];
class EquipmentViewModal extends React.Component {
    constructor() {
        super(...arguments);
        this.hide = () => this.props.onHide();
    }
    render() {
        return (React.createElement(Modal, { dialogClassName: "modal-override", show: this.props.show, onHide: () => this.hide(), enforceFocus: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, "Equipment Details")),
            React.createElement(Modal.Body, null,
                React.createElement("div", { className: "my-2" },
                    React.createElement("div", { className: "flex text-grey-darker" }, HEADERS.map((header, i) => {
                        return (React.createElement("div", { key: getKey(header, i), className: "w-1/4" },
                            React.createElement("strong", null, header)));
                    }))),
                React.createElement("div", { className: "mb-2" },
                    React.createElement(EquipmentViewRow, { equipment: this.props.equipment }))),
            React.createElement(Modal.Footer, null,
                React.createElement("div", { className: "float-right" },
                    React.createElement("div", null,
                        React.createElement("a", { onClick: () => this.hide(), className: "mr-1" }, "Close"))))));
    }
}
EquipmentViewModal.propTypes = {
    equipment: PropTypes.object,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
};
export default EquipmentViewModal;
function getKey(header, i) {
    return `${header}-${i}`;
}
